import { type OrderStatus, orderStatusSchema } from './orderStatusSchema';

export const orderPipelineStatuses = [
    'Paid',
    'BuyingItems',
    'ShippingToRussia',
    'ShippingByCdek',
    'Completed',
] as const satisfies OrderStatus[];

export const orderPipelineStatusSchema = orderStatusSchema.extract(orderPipelineStatuses);

export type OrderPipelineStatus = (typeof orderPipelineStatuses)[number];
